module.exports = __webpack_public_path__ + "static/screenshot3-944b75c11822f034d3aa6498d7ddcdf1.png";